import { render, staticRenderFns } from "./DeskEditor.vue?vue&type=template&id=3b165073&scoped=true&"
import script from "./DeskEditor.vue?vue&type=script&lang=js&"
export * from "./DeskEditor.vue?vue&type=script&lang=js&"
import style0 from "./DeskEditor.vue?vue&type=style&index=0&id=3b165073&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b165073",
  null
  
)

export default component.exports